/**
 * Created by dyc on 2018/4/4.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, Table, message, Progress} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew, DisplayForm} from '../../components';
import {openNotice, config} from 'Utils';
import {detail} from '../../service/customOrder';
import {getPro, getItem} from '../../service/shoppingCar';

import moment from 'moment';

class CustomOrderDetail extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['定制订单'],
            showHideBtnIndex: '',
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: [],
            total: 1,
            tempArr: [],
            width: '',
            searchObj: {
                name: '',
                category: [],
                active: '',
                s: 10,
                p: 1
            },
            categoryData: [],
            visible: false,
            approvalMessagevisible: false,
            value: '',
            alreadyTotal: '',
            alreadyRows: '',
            cusId: '',
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || '',
            params: {},
            loading: true,
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.goBack = this.goBack.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
    };

    /*筛选重置*/
    advanceReset() {
    };

    /* 筛选确认 */
    advanceSubmit(form) {
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        var self = this;
        var curChannel = window.sessionStorage.getItem('cur_channel');
        curChannel = curChannel.split('|');
        var length = curChannel.length - 1;
        var curChannelId = curChannel[length];
        var cusId;
        self.setState({loading: true});
        detail(self.props.params).then(result => {
            // debugger
            if (result.status && result.status == true) {
                self.setState({
                    resultData: [result.data],
                    rows: result.data.productList,
                    PROD_FLAG: result.data.productList[0].erpData.PROD_FLAG,
                    cusId: result.data.cusId,
                    userId: result.data.userId,
                    customerName: result.data.customerName,
                    loading: false,
                })
                cusId = result.data.cusId;
                getPro({
                    customerId: cusId,
                    channelCode: curChannelId,
                    p: 1,
                    s: 10
                }).then(result => {
                    if (result.status) {
                        // debugger
                        // console.log(result)
                        self.setState({
                            alreadyRows: result.data,
                            alreadyTotal: result.total
                        });
                    } else {
                        message.error(result.message);
                    }
                });
                // console.dir(result.data)
            } else {
                message.error(result.message);
            }
        });
        // console.log(cusId)

        // debugger

    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {

        this.initData();
    }

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);

    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    addRecord(index) {
        console.log('adding ' + index);
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        // console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value
        });
    }

    handleChange() {

    }

    handleT = () => {
        this.setState({approvalMessagevisible: false});
    }

    handleF = () => {
        this.setState({approvalMessagevisible: false});
    };
    chackedStatus = (record, index) => {
        const erpData = record.erpData;
        // console.log(erpData);
        let initTempArr = [{
            "operation": "已提交",
            "content": "",
            "personal": '',
            "createdDate": new Date(record.createdDate).format('yyyy-MM-dd hh:mm:ss'),
        }];
        if (erpData.EA_FLAG) {
            initTempArr.push({
                    "operation": "环保确认",
                    "content": erpData.EA_FLAG,
                    "personal": erpData.EA_PERSON,
                    "createdDate": erpData.EA_DATE,
                },
            );
        }
        if (erpData.ATTRIBUTE10) {
            initTempArr.push({
                    "operation": "生产确认",
                    "content": erpData.ATTRIBUTE15,
                    "personal": erpData.ENGINEER_NAME,
                    "createdDate": erpData.ATTRIBUTE10,
                },
            );
        }
        if (erpData.ATTRIBUTE11) {
            initTempArr.push({
                "operation": " 成本确认",
                "content": '',
                "personal": erpData.SIGN_NAME3,
                "createdDate": erpData.ATTRIBUTE11,
            });
        }
        if (erpData.ATTRIBUTE12) {
            initTempArr.push({
                "operation": "物料确认",
                "content": erpData.ITEM_NUM + ' ' + erpData.ITEM_DESC,
                "personal": erpData.SIGN_NAME,
                "createdDate": erpData.ATTRIBUTE12,
            })
        }
        if (erpData.T_DATE) {
            initTempArr.push({
                "operation": "市场部反馈",
                "content": erpData.PRICE,
                "personal": erpData.SIGN_NAME4,
                "createdDate": erpData.T_DATE,
            })
        }
        this.setState({tempArr: initTempArr});
        this.setState({approvalMessagevisible: true});
    }

    changeZheng = () => {
        let params = {
            userId: this.state.userId,
            customerName: this.state.customerName,
            cusId: this.state.cusId,
        }
        let resultData2 = this.state.rows;

        let curChannel = window.sessionStorage.getItem('cur_channel');
        curChannel = curChannel.split('|');
        let length = curChannel.length - 1;
        let curChannelId = curChannel[length];

        let flag = true;
        let message = null;

        let rowcount = 0;

        Object.assign(resultData2);

        for (let i = 0; i < resultData2.length; i++) {
            if (resultData2[i].erpData.ITEM_NUM == null) {
                delete resultData2[i];
            }
        }


        for (let i = 0; i < resultData2.length; i++) {
            if (resultData2[i].productId == null) {
                flag = false;
                if (!message) {
                    message = String(resultData2[i].erpData.ITEM_NUM)
                } else {
                    message = message + '；' + String(resultData2[i].erpData.ITEM_NUM)
                }
                rowcount++;
            } else {
                getItem({
                    channelCode: curChannelId,
                    customerId: this.state.cusId,
                    name: resultData2[i].erpData.ITEM_NUM,
                    p: 1,
                    s: 1,
                }).then(result => {
                    if (result.status && result.code == 200) {
                        rowcount++;
                        if (result.total > 0) {
                            console.log(resultData2[i].erpData);
                            resultData2[i].erpData.ITEM_DESC = result.data[0].itemDesc;
                            resultData2[i].erpData.PRICE = result.data[0].showPrice;
                            resultData2[i].productId = result.data[0].id;
                        }

                        if (rowcount == resultData2.length) {

                            if (!flag) {
                                openNotice('warning', '物料编码：' + String(message) + '状态或价格有误，请联系天正前台检查！');
                                return;
                            }

                            function bouncer(arr) {
                                // Don't show a false ID to this bouncer.
                                return arr.filter(function (val) {
                                    return !(!val || val === "");
                                });
                            }

                            let x = bouncer(resultData2)
                            window.sessionStorage.setItem('dingPassParse', JSON.stringify(x));
                            this.goView(`/shoppingCar/add1/${'5'}&${params.cusId}&${params.customerName}&${params.userId}`)

                        }

                    } else {
                        message.error(result.message);
                    }
                });
            }

        }
    }

    render() {
        const {
            params,
            opts,
            key,
            rows,
            total,
            width,
            searchObj,
            tempArr,
            selectedRowKeys,
            showHideBtnIndex,
            visible,
            approvalMessagevisible,
            resultData,
            loading,
            userData
        } = this.state;

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 1000, y: false},
            columns: [
                {
                    title: '产品线',
                    dataIndex: 'proLine'
                }, {
                    title: '大类',
                    dataIndex: 'proBigType'
                },
                {
                    title: '中类',
                    dataIndex: 'proMiddleType'
                },
                {
                    title: '明细类',
                    dataIndex: 'proDetailType'
                },
                {
                    title: '物料名称',
                    dataIndex: 'proContent',
                    render: text => <span style={{whiteSpace: 'prewrap'}}>{text}</span>
                },
                {
                    title: '规格',
                    dataIndex: 'specUnionKey'
                },
                {
                    title: '环保属性',
                    dataIndex: 'environmentalAttributes'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '生产公司',
                    dataIndex: 'proCompany'
                },
                {
                    title: '工程师',
                    dataIndex: 'engineerName'
                },
                {
                    title: '工程师电话',
                    dataIndex: 'engineerPhone'
                },
                {
                    title: '数量',
                    dataIndex: 'count'
                },
                {
                    title: '需求日期',
                    dataIndex: 'needDate',
                    render: text => new Date(text).format('yyyy-MM-dd hh:mm')
                },
                {
                    title: '确认物料名称',
                    dataIndex: 'erpData.ITEM_DESC'
                },
                {
                    title: '确认物料编码',
                    dataIndex: 'erpData.ITEM_NUM'
                },
                {
                    title: '是否能生产',
                    dataIndex: 'erpData.PROD_FLAG'
                },
                {
                    title: '确认人电话',
                    dataIndex: 'erpData.ATTRIBUTE4'
                },
                {
                    title: '确认牌价',
                    dataIndex: 'erpData.PRICE'
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    render: (text, record, index) => (
                        <div>
                            <Button style={{color: '#d61418'}}
                                    onClick={this.chackedStatus.bind(this, record, index)}>
                                查看状态
                            </Button>
                            {/*<a style={{display: record.enclosureId ? 'block' : 'none'}}
                href={`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${detail.enclosureId}`}
            >查看附件</a>*/}
                        </div>)
                }
            ],
            rows
        };
        let hasData = false;
        if (resultData.length > 0) {
            hasData = true;
        }
        const displayData = [
            {label: '编号', value: hasData ? resultData[0].code : ''},
            {label: '状态', value: hasData ? resultData[0].orderStatus : ''},
            {
                label: '订单日期',
                value: hasData ? moment(parseInt(resultData[0].createdDate)).format('YYYY-MM-DD HH:mm:ss') : ''
            },
            {label: '客户编号', value: hasData ? resultData[0].customerCode : ''},
            {label: '客户名称', value: hasData ? resultData[0].customerName : ''},
            {label: '联系电话', value: hasData ? resultData[0].phone : ''},
            {label: '备注', value: hasData ? resultData[0].remark : ''}
        ];
        // const tempArr = [{"p":null,"s":null,"ids":null,"orderField":null,"orderString":null,"reqType":null,"id":2,"relatedType":1,"orderId":2,"operation":"已提交","content":"","createdDate":"2017-12-27 10:05:30","createdBy":2258,"lastUpdatedDate":null,"lastUpdatedBy":null,"removeFlag":0,"itemselector":null},{"p":null,"s":null,"ids":null,"orderField":null,"orderString":null,"reqType":null,"id":3,"relatedType":1,"orderId":2,"operation":"生产公司确认","content":"可以生产","createdDate":"2017-12-27 10:06:55","createdBy":2257,"lastUpdatedDate":null,"lastUpdatedBy":null,"removeFlag":0,"itemselector":null},{"p":null,"s":null,"ids":null,"orderField":null,"orderString":null,"reqType":null,"id":4,"relatedType":1,"orderId":2,"operation":"前台","content":"物料已录入","createdDate":"2017-12-27 10:07:15","createdBy":2257,"lastUpdatedDate":null,"lastUpdatedBy":null,"removeFlag":0,"itemselector":null}];
        let orderRecordHtml = (tempArr).map(function (qst, key) {
            console.log(qst.operation);

            if (qst.operation == "异常") {
                return <a className="already" key={key}>
                    <Progress className="index" type="circle" percent={70} format={() => key + 1} width={50}
                              status="exception"></Progress>
                    <p className="f">{qst.operation}</p>
                    <p className="f" style={{height: 50}}>{qst.content}</p>
                    <p className="f" style={{height: 33}}>{qst.personal}</p>
                    <p className={(qst.createdDate && qst.createdDate.length > 0) ? '' : 'no'}>{qst.createdDate || '-'}</p>
                    <span style={{display: key == (tempArr.length - 1) ? 'none' : 'inline-block'}}
                          className="l"></span>
                </a>
            }
            return <a className="already" key={key}>
                <Progress className="index" type="circle" percent={100} format={() => key + 1}
                          width={50}></Progress>
                <p className="f">{qst.operation}</p>
                <p className="f" style={{height: 50}}>{qst.content}</p>
                <p className="f" style={{height: 33}}>{qst.personal}</p>
                <p className={(qst.createdDate && qst.createdDate.length > 0) ? '' : 'no'}>{qst.createdDate || '-'}</p>
                <span style={{display: key == (tempArr.length - 1) ? 'none' : 'inline-block'}} className="l"></span>
            </a>
        });
        return (
            <div className="dms-main-box">
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        {userData.roleCode != 'CUSTOMER_INQUIRY' && hasData && resultData[0].changeOrder ?
                            <Button onClick={this.changeZheng.bind(this)}
                                    style={{display: !this.state.PROD_FLAG || this.state.PROD_FLAG == false ? 'none' : 'inline-block'}}>转正式订单</Button> : null}
                        <Button onClick={this.goBack}>返回</Button>
                    </DmsTab>
                    <div className="dms-table-box">
                        <DisplayForm dataSource={displayData} perRow="4"/>
                        <div>
                            <DmsTab className="white-bg no-border" options={['订单物料']} defaultKey={0}/>
                            <div className="dms-table-box">
                                <TableView {...tableViewProps} />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    visible={approvalMessagevisible}
                    maskClosable={false}
                    onOk={this.handleT}
                    onCancel={this.handleF}
                    width={1200}
                    footer={null}
                >
                    <DmsTab className="white-bg no-border" options={['审批信息']} defaultKey={0}/>
                    <div className="dms-table-box">
                        <div className="order_detail">
                            <div className="opt">
                                {orderRecordHtml}
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    visible={visible}
                    title="转正式订单"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                >
                    <div>
                        <Row>
                            <Col>
                                <label>购货单位：</label>
                            </Col>
                            <Col>
                                <Select defaultValue="lucy" style={{width: 200}}>
                                    <Select.Option value="lucy">佛山金胜义</Select.Option>
                                    <Select.Option value="lucy1">佛山金胜义1</Select.Option>
                                    <Select.Option value="lucy2">佛山金胜义2</Select.Option>
                                </Select>
                            </Col>
                        </Row>
                        <Row style={{marginTop: '15px'}}>
                            <Col>
                                <label>渠道：</label>
                            </Col>
                            <Col>
                                <Select defaultValue="lucy" style={{width: 200}}>
                                    <Select.Option value="lucy">分销</Select.Option>
                                    <Select.Option value="lucy1">电力</Select.Option>
                                    <Select.Option value="lucy2">合作伙伴</Select.Option>
                                </Select>
                            </Col>
                        </Row>
                        <Row style={{marginTop: '15px'}}>
                            <Col>
                                <label>订单类型：</label>
                            </Col>
                            <Col>
                                <Select defaultValue="lucy" style={{width: 200}}>
                                    <Select.Option value="lucy">常规订单</Select.Option>
                                    <Select.Option value="lucy1">项目订单</Select.Option>
                                    <Select.Option value="lucy2">合作伙伴发展</Select.Option>
                                </Select>
                            </Col>
                        </Row>
                    </div>
                </Modal>

            </div>
        )
    }
}
;
export default withRouter(CustomOrderDetail);


// WEBPACK FOOTER //
// ./src/routes/customOrder/detail.js